import React, { Component } from 'react';
import { shape, string } from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PersonalizedContentServiceAction from '../../actions/PersonalizedContentServiceAction';

export class PersonalizedContentService extends Component {
    static propTypes = {
        location: shape({
            search: string,
        }),
        personalizedContentService: shape({
            CacheControl: string,
        }),
    };

    static defaultProps = {
        location: {
            search: '',
        },
        personalizedContentService: {},
    };

    constructor(props) {
        super(props);
        this.query = props.location && makeQuery(props.location.search);
        const irisRequestParams = {
            audience: this.query.audience,
            location: this.query.location,
        };

        if (!Object.keys(props.personalizedContentService).length && irisRequestParams.location) {
            props.actions.getIrisPersonalizedContentService(irisRequestParams);
        }
    }

    state = {
        personalizedContentService: null,
    };

    static getDerivedStateFromProps(props, state) {
        if (!_isEqual(props.personalizedContentService, state.personalizedContentService)) {
            return {
                personalizedContentService: props.personalizedContentService,
            };
        }
        return null;
    }

    render() {
        return !_isEmpty(this.state.personalizedContentService) ? (
            <div data-pcid="personalizedIrisResponse">
                {JSON.stringify({
                    ...this.state.personalizedContentService,
                    audience: this.query && this.query.audience,
                })}
            </div>
        ) : null;
    }
}

export const mapStateToProps = (state) => ({
    personalizedContentService: state.personalizedContentService,
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...PersonalizedContentServiceAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalizedContentService);
